import React from 'react';
import { examples } from '../../data/examples'; // Correct: Import from examples.js
import './Modal.css';

const ExamplesModal = ({ type, onClose }) => {
  const [isVisible, setIsVisible] = React.useState(false);
  
  // Get the examples directly from the imported data based on the 'type' (which is the id)
  const exampleData = examples[type];

  // Effect para la animación de entrada
  React.useEffect(() => {
    if (exampleData) {
      setIsVisible(true);
    }
  }, [exampleData]);

  // If no data is found for that type, don't render the modal
  if (!exampleData) {
    console.error(`No examples found for type: ${type}`);
    return null;
  }

  const handleClose = () => {
    setIsVisible(false);
    // Delay para permitir que la animación de salida termine
    setTimeout(() => {
      onClose();
    }, 300);
  };

  return (
    <div className={`modal ${isVisible ? 'visible' : ''}`} onClick={handleClose}>
      <div className={`modal-content ${isVisible ? 'visible' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className="close" onClick={handleClose}>&times;</span>
          {/* Render the title directly as a string */}
          <h2 className="modal-title">
            {exampleData.title}
          </h2>
          <div className="modal-subtitle">
            {exampleData.content.length} ejemplos disponibles
          </div>
        </div>
        <div className="examples-grid">
          {/* Map over the content, which is an array of strings */}
          {exampleData.content.map((example, index) => (
            <div key={index} className="example-card">
              <div className="example-header">
                <strong>Ejemplo {index + 1}</strong>
                <span className="example-badge">#{index + 1}</span>
              </div>
              {/* Render the example string directly */}
              <div className="example-eng">
                {example}
              </div>
            </div>
          ))}
        </div>
        <div className="modal-footer">
          <button className="close-button" onClick={handleClose}>
            ✕ Cerrar y Volver
          </button>
          <div className="modal-tip">
            💡 Tip: Al cerrar regresarás automáticamente al botón que abriste
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamplesModal;
